// src/lib/client/external-referrer.ts
//
// Acquisition attribution for the web UI. The Referer header on a same-origin
// API fetch is always OUR OWN tool page, so the server can never see where the
// visitor actually came from — measured in production: referrer_host was NULL
// on every funnel row ever written (docs/funnel/README.md "Known limits").
//
// Fix: forward the LANDING referrer's host (document.referrer) explicitly.
// document.referrer is set once per document load, so it survives App Router
// soft navigations — first-touch attribution for the whole SPA session.
//
// Privacy contract (app/legal/privacy): funnel events never contain full
// referring URLs. Only the HOST leaves the browser; nothing is persisted
// client-side. Our own host is skipped — it is not acquisition signal.
//
// Trust class: same as the x-scholar-client handshake — a client-supplied
// attribution hint, never auth proof. proxy.ts's trust-boundary scrub only
// deletes middleware-issued proof headers, so this one passes through.

/** Request header carrying the external landing-referrer host. */
export const X_SCHOLAR_REFERRER = "x-scholar-referrer";

/**
 * `{ "x-scholar-referrer": host }` for spreading into a fetch `headers`
 * object, or `{}` on the server, with no referrer, or when the referrer is
 * this site itself.
 */
export function externalReferrerHeader(): Record<string, string> {
  try {
    if (typeof document === "undefined" || !document.referrer) return {};
    const url = new URL(document.referrer);
    if (url.host === window.location.host) return {};
    const host = url.hostname.toLowerCase();
    if (!host || host.length > 253) return {};
    return { [X_SCHOLAR_REFERRER]: host };
  } catch {
    return {};
  }
}
